import React, { Component } from "react";
import { Card, Row, Col, Typography,  Space, message, Modal, Spin } from "antd"; 
import { PlayCircleOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import axios from "axios";
import ModalAgregarTutorial from "./AgregarTutorial/AgregarTutoral";
import ModalEditarTutorial from "./EditarTutorial/EditarTutorial";
import ButtonItem from "../../../../Components/ButtonItem";
import { connect } from "react-redux";
import InputItem from "../../../../Components/InputItem";

const { Title, Text } = Typography;

class Tutoriales extends Component {
  state = {
    videos: [],
    loading: false,
    modalAgregarVisible: false,
    modalEditarVisible: false,
    modalVerVisible: false,
    selectedVideo: null,
    videoParaVer: null,
    searchText: ""
  };

  componentDidMount() {
    this.cargarVideos();
  }

  habilitarTutorial = async (video) => {
  try {
    await axios.put("tutoriales/habilitarTutorial", {
      _id: video._id,
      activo: 1
    });

    message.success("Tutorial habilitado");
    this.cargarVideos();
  } catch (error) {
    console.error(error);
    message.error("Error al habilitar el tutorial");
  }
};

deshabilitarTutorial = async (video) => {
  try {
    await axios.put("tutoriales/deshabilitarTutorial", {
      _id: video._id,
      activo: 0
    });

    message.success("Tutorial deshabilitado");
    this.cargarVideos();
  } catch (error) {
    console.error(error);
    message.error("Error al deshabilitar el tutorial");
  }
};


  obtenerVideoId = (url) => {
    if (!url) return "";
    const regExp = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|watch\?v=))([^?&]+)/;
    const match = url.match(regExp);
    return match ? match[1] : "";
  };

  cargarVideos = async () => {
    this.setState({ loading: true });
    try {
        let data;
      if (this.props.empresaId === "66f196f27a90444bd4d4f533") {
          data = await axios.post("tutoriales/selectTodasTutoriales", {});
        }else{
          data = await axios.post("tutoriales/selectTutoriales", {});
      }
      this.setState({ videos: data.data.tutoriales, loading: false });
    } catch (error) {
      console.error(error);
      message.error("Error al cargar los tutoriales");
      this.setState({ loading: false });
    }
  };

  abrirModalAgregar = () => {
    this.setState({ modalAgregarVisible: true });
  };

  abrirModalEditar = (video) => {
    this.setState({ selectedVideo: video, modalEditarVisible: true });
  };

  abrirModalVerVideo = (video) => {
    this.setState({ videoParaVer: video, modalVerVisible: true });
  };

  cerrarModales = () => {
    this.setState({
      modalAgregarVisible: false,
      modalEditarVisible: false,
      modalVerVisible: false,
      selectedVideo: null,
      videoParaVer: null
    });
  };

  render() {
    const {
        videos,
        modalAgregarVisible,
        modalEditarVisible,
        modalVerVisible,
        selectedVideo,
        videoParaVer,
        searchText
    } = this.state;

    // Validar empresa autorizada
    const ES_ID = "66f196f27a90444bd4d4f533";
    const esEmpresaAutorizada = this.props.empresaId === ES_ID;

    const videosFiltrados = videos.filter((v) =>
        (v.titulo + " " + v.descripcion).toLowerCase().includes(searchText.toLowerCase())
    );

    return (
      <Spin spinning={this.state.loading} size="large">
        <div style={{ padding: "20px 0" }}>

        {/* HEADER */}
        <div style={{ marginBottom: 24, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
            <Title level={3}>
                <PlayCircleOutlined style={{ marginRight: 8 }} />
                Tutoriales en Video
            </Title>
            <Text type="secondary">Aprende a usar el sistema con nuestros tutoriales paso a paso</Text>
            </div>

            {esEmpresaAutorizada && (
            <ButtonItem type="primary" icon={<PlusOutlined />} onClick={this.abrirModalAgregar}>
                Agregar Tutorial
            </ButtonItem>
            )}
        </div>

        {/* BUSCADOR */}
        <div style={{ marginBottom: 20 }}>
            <InputItem
            placeholder="Buscar tutorial por título o descripción..."
            allowClear
            enterButton="Buscar"
            size="large"
            onChange={(e) => this.setState({ searchText: e.target.value })}
            style={{ maxWidth: 400 }}
            />
        </div>

        <Row gutter={[24, 24]}>
            {videosFiltrados.map((video) => (
            <Col
                xs={24}
                sm={12}
                md={8}
                lg={6}
                xl={4}
                style={{ flex: "0 0 20%", maxWidth: "20%" }}
                key={video._id}
            >
                <Card
                hoverable
                bordered={false}
                style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                onClick={() => this.abrirModalVerVideo(video)}
                >
                <div
                    style={{
                    position: "relative",
                    paddingBottom: "56.25%",
                    height: 0,
                    overflow: "hidden",
                    marginBottom: 16,
                    borderRadius: 8
                    }}
                >
                    <img
                    src={`https://img.youtube.com/vi/${this.obtenerVideoId(video.url)}/hqdefault.jpg`}
                    alt={video.titulo}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                    }}
                    />
                </div>

                <div>
                    <Title level={5}>{video.titulo}</Title>
                    <Text type="secondary" style={{ display: "block" }}>
                    {video.descripcion}
                    </Text>

                    {/* Solo empresa autorizada puede editar */}
                    {esEmpresaAutorizada && (
                        <Space style={{ marginTop: 12 }}>
                            {/* Botón Editar */}
                            <ButtonItem
                            icon={<EditOutlined />}
                            type="default"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.abrirModalEditar(video);
                            }}
                            >
                            Editar
                            </ButtonItem   >
                            {video.estado === 1 && (
                            <ButtonItem
                                danger
                                type="primary"
                                onClick={(e) => {
                                e.stopPropagation();
                                this.deshabilitarTutorial(video);
                                }}
                            >
                                Deshabilitar
                            </ButtonItem>
                            )}
                            {video.estado === 0 && (
                            <ButtonItem 
                                type="default"
                                verde
                                onClick={(e) => {
                                e.stopPropagation();
                                this.habilitarTutorial(video);
                                }}
                            >
                                Habilitar
                            </ButtonItem>
                            )}
                        </Space>
                        )}

                </div>
                </Card>
            </Col>
            ))}
        </Row>

        {/* MODAL AGREGAR (solo si autorizado) */}
        {esEmpresaAutorizada && (
            <ModalAgregarTutorial
            visible={modalAgregarVisible}
            onClose={this.cerrarModales}
            recargar={this.cargarVideos}
            />
        )}

        {/* MODAL EDITAR (solo si autorizado) */}
        {esEmpresaAutorizada && (
            <ModalEditarTutorial
            visible={modalEditarVisible}
            onClose={this.cerrarModales}
            recargar={this.cargarVideos}
            video={selectedVideo}
            />
        )}

        {/* MODAL VER VIDEO (siempre disponible) */}
        <Modal
            title={videoParaVer ? videoParaVer.titulo : ""}
            visible={modalVerVisible}
            onCancel={this.cerrarModales}
            footer={null}
            width={800}
            destroyOnClose
        >
            {videoParaVer && (
            <div
                style={{
                position: "relative",
                paddingBottom: "56.25%",
                height: 0,
                overflow: "hidden",
                borderRadius: 8
                }}
            >
                <iframe
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: 0
                }}
                src={
                    modalVerVisible && videoParaVer
                    ? `https://www.youtube.com/embed/${this.obtenerVideoId(videoParaVer.url)}?autoplay=1`
                    : ""
                }
                title={videoParaVer?.titulo}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                />
            </div>
            )}
        </Modal>
        </div>
      </Spin>
    );
    }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Tutoriales);